import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-container-spinner',
  templateUrl: './container-spinner.component.html',
  styleUrls: []
})
export class ContainerSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
